import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getVerifyCodeApi = (params) => {
  return httpService({
    url: contextPath + '/user/item/sendVerifyCode',
    method: 'get',
    params
  })
}

export const userRegisterApi = (data) => {
  return httpService({
    url: contextPath + '/user/item/register',
    method: 'post',
    data
  })
}

export const userNameLoginApi = (params) => {
  return httpService({
    url: contextPath + '/user/item/login',
    method: 'get',
    params
  })
}

export const userIsExistApi = (params) => {
  return httpService({
    url: contextPath + '/user/item/isExist',
    method: 'get',
    params
  })
}

export const verificationLoginApi = (params) => {
  return httpService({
    url: contextPath + '/user/item/loginByVerifyCode',
    method: 'get',
    params
  })
}

export const changePasswordApi = (params) => {
  return httpService({
    url: contextPath + '/user/item/changePassword',
    method: 'put',
    params
  })
}

export const forgotPasswordApi = (params) => {
  return httpService({
    url: contextPath + '/user/item/forgotPassword',
    method: 'put',
    params
  })
}

export const createUserApi = (data) => {
  return httpService({
    url: contextPath + '/user/item/addByAdmin',
    method: 'post',
    data
  })
}

export const deleteUserApi = (params) => {
  return httpService({
    url: contextPath + '/user/item/deleteByAdmin',
    method: 'delete',
    params
  })
}

export const updateUserApi = (data) => {
  return httpService({
    url: contextPath + '/user/item/changeBaseByAdmin',
    method: 'put',
    data
  })
}

// 重置密码
export const resetPasswordUserApi = params => {
  return httpService({
    url: contextPath + '/user/reset/password/',
    method: 'put',
    params
  })
}


export const changeBaseApi = (data) => {
  return httpService({
    url: contextPath + '/user/item/changeBase',
    method: 'put',
    data
  })
}

export const queryUserApi = (params) => {
  return httpService({
    url: contextPath + '/user/info',
    method: 'get',
    params
  })
}

//  用户组管理
//  用户组信息添加
export const detail = (data) => {
  return httpService({
    url: contextPath + '/user/group/detail',
    method: 'post',
    data
  })
}
//  用户组信息修改
export const detailEdit = (data) => {
  return httpService({
    url: contextPath + '/user/group/detail',
    method: 'PUT',
    data
  })
}
//  用户组删除
export const detailDelete = (id) => {
  return httpService({
    url: contextPath + `/user/group/${id}`,
    method: 'delete'
  })
}
//  根据ID查询详情
export const detailId = (id) => {
  return httpService({
    url: contextPath + `/user/group/${id}`,
    method: 'get'
  })
}
//  用户组列表查询
export const info = () => {
  return httpService({
    url: contextPath + `/user/group/info`,
    method: 'get'
  })
}

//  查询未分配人员信息
export const notAllot = (params) => {
  return httpService({
    url: contextPath + `/user/item/notAllot`,
    method: 'get',
    params
  })
}
//  用户组成员添加
export const detailMember = (data) => {
  return httpService({
    url: contextPath + '/user/group/member/detail',
    method: 'post',
    data
  })
}
//  用户组成员移除
export const detailMemberDelete = (id) => {
  return httpService({
    url: contextPath + `/user/group/member/detail/${id}`,
    method: 'delete'
  })
}
